import React, { Component } from 'react';
import { connect } from 'react-redux';

import NativeSelect from '@material-ui/core/NativeSelect';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import { SORT_ASC } from 'ra-core/lib/reducer/admin/resource/list/queryReducer';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, PieChart, Pie, Sector, Cell
} from 'recharts';
import CompanyList from '../../../components/UrCompanyList';
import {
  restClient,
  getDateString,
  addCounters,
  formatPercentages,
  formatRubMoney,
  aggregateSum,
  aggregatePercentages, getDateByDayId, CALLCENTER_PLAN, dateToHtmlInputDate
} from '../../../common';
import CustomerDatagrid from './Datagrid';
import EjectedList from '../../../components/ejected/List';

import Header from './Header';

import DatePickers from '../../../components/DatePickers';

import { updateCounters as updateCountersAction } from '../../../redux/actions';


const StyledNativeSelect = withStyles({
  select: {
    width: '173px'
  }
})(NativeSelect);

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      companies: [],
      filter: {
        company: 'all',
        plan: 'all',
        'date-from': getDateByDayId(-120).toISOString(),
        'date-to': getDateByDayId(0, true).toISOString(),
        groupBy: '$subject_new'
      },
      showTable: true,
    };
    Promise.all([
      restClient('GET_CUSTOM', 'getCompaniesList', {
        plan: 'all',
        'date-from': this.state.filter['date-from'],
        'date-to': this.state.filter['date-to'],
      }),
      restClient('GET_CUSTOM', 'statistics-subject', {
        company: 'all',
        'date-from': this.state.filter['date-from'],
        'date-to': this.state.filter['date-to'],
        plan: this.state.filter.plan,
      })
    ]).then(values => {
      this.props.updateCounters(values[1][0]);
      this.setState({
        companies: values[0],
      });
    });
  }

  onCompanySelect(companyId) {
    this.setState({
      filter: {
        ...this.state.filter,
        company: companyId
      }
    });
    restClient('GET_CUSTOM', 'statistics-subject', {
      company: companyId,
      'date-from': this.state.filter['date-from'],
      'date-to': this.state.filter['date-to'],
      plan: this.state.filter.plan,
    }).then(res => {
      this.props.updateCounters(res[0]);
    });
  }

  onPlanSelect(evt) {
    const plan = evt.target.value;

    this.setState({
      filter: {
        ...this.state.filter,
        plan,
        company: 'all'
      }
    });

    Promise.all([
      restClient('GET_CUSTOM', 'getCompaniesList', {
        plan,
        'date-from': this.state.filter['date-from'],
        'date-to': this.state.filter['date-to'],
      }),
      restClient('GET_CUSTOM', 'statistics-subject', {
        company: 'all',
        'date-from': this.state.filter['date-from'],
        'date-to': this.state.filter['date-to'],
        plan,
      })
    ]).then(values => {
      this.props.updateCounters(values[1][0]);
      this.setState({
        companies: values[0]
      });
    });
  }


  onDateChangeFrom(evt) {
    const date = new Date(evt.target.value);
    date.setHours(0, 0, 0, 0);
    const resultDate = date.toISOString();

    this.setState({
      filter: {
        ...this.state.filter,
        'date-from': resultDate
      }
    });

    Promise.all([
      restClient('GET_CUSTOM', 'statistics-subject', {
        company: this.state.filter.company,
        'date-from': resultDate,
        'date-to': this.state.filter['date-to'],
        plan: this.state.filter.plan,
      }),
      restClient('GET_CUSTOM', 'getCompaniesList', {
        plan: this.state.filter.plan,
        'date-from': resultDate,
        'date-to': this.state.filter['date-to'],
      })
    ]).then(values => {
      this.props.updateCounters(values[0][0]);
      this.setState({
        companies: values[1]
      });
    });
  }

  onDateChangeTo(evt) {
    const date = new Date(evt.target.value);
    date.setHours(23, 59, 59, 999);
    const resultDate = date.toISOString();

    this.setState({
      filter: {
        ...this.state.filter,
        'date-to': resultDate,
      }
    });

    Promise.all([
      restClient('GET_CUSTOM', 'statistics-subject', {
        company: this.state.filter.company,
        'date-from': this.state.filter['date-from'],
        'date-to': resultDate,
        plan: this.state.filter.plan,
      }),
      restClient('GET_CUSTOM', 'getCompaniesList', {
        plan: this.state.filter.plan,
        'date-from': this.state.filter['date-from'],
        'date-to': resultDate,
      })
    ]).then(values => {
      this.props.updateCounters(values[0][0]);
      this.setState({
        companies: values[1]
      });
    });
  }

  showTableClick(evt, value) {
    this.setState({
      showTable: value,
      filter: {
        ...this.state.filter,
        refreshToken: Math.random(),
      }
    });
  }

  getCompanyName() {
    const id = this.state.filter.company;
    if (id === 'all') {
      return 'по Всем Юридическим Компаниям';
    }
    return `по ${this.state.companies.find(company => company.id === this.state.filter.company).name}`;
  }


  getTitle(companies, filter) {
    // if (companies.length && filter && filter.company && filter['date-to']) return `Статистика ${this.getCompanyName()} на ${getDateString(new Date(filter['date-to']))}, в , `;
    if (companies.length && filter && filter.company) return `Статистика ${this.getCompanyName()} `;
    // if (filter && filter['date-to']) return `Статистика на ${getDateString(new Date(filter['date-to']))}, `;
    return 'Статистика';
  }

  render() {
    const passedProps = { ...this.props };
    delete (passedProps.resData);
    delete (passedProps.resIds);
    delete (passedProps.updateCounters);
    const resData = this.props.resData;
    const resIds = this.props.resIds;
    const tableData = resIds.map(val => resData[val]);
    // if (tableData !== undefined) {
    //   tableData = tableData.reverse();
    // }
    const countersFunc = company => ({
      counters: [
        { count: company.count, style: { color: '#2C9BC3' } },
        { count: company.visited, style: { color: '#35CD59' } },
        { count: company.ctr, formatFunc: formatPercentages, style: { color: '#353535' } },
        { count: company.sum, formatFunc: formatRubMoney, style: { color: '#353535' } }
      ]
    });

    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042',
      '#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6',
      '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
      '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
      '#FF99E6', '#FF1A66', '#E6331A', '#33FFCC', '#66994D',
      '#B366CC', '#4D8000', '#B33300', '#CC80CC',
      '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
      '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
      '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
      '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
      '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'];

    return (
      <div className="col-wrapper">
        <div className="col-menu">
          <StyledNativeSelect
            value={this.state.filter.plan}
            onChange={this.onPlanSelect.bind(this)}
            style={{
              marginLeft: '20px',
              marginTop: '9px'
            }}
          >
            <option key="all" value="all">Все типы</option>
            {this.props.plans.map(({ _id, callcenters }) => {
              const callcentersArray = callcenters.map((callcenter) => <option key={callcenter.id} value={callcenter.id}>- {callcenter.name}</option>);
              const planTree = [<option key={_id} value={_id}>{CALLCENTER_PLAN.find(callcenter => callcenter.id === _id).name}</option>];
              return planTree.concat(callcentersArray);
            })}
          </StyledNativeSelect>
          <CompanyList
            data={addCounters(countersFunc)(this.state.companies)}
            selectedId={this.state.filter.company}
            onSelect={this.onCompanySelect.bind(this)}
            aggregate={{
              title: 'Все Юридические Компании',
              counters: [
                { count: aggregateSum(this.state.companies, 'count'), style: { color: '#2C9BC3' } },
                { count: aggregateSum(this.state.companies, 'visited'), style: { color: '#35CD59' } },
                { count: aggregatePercentages(this.state.companies), formatFunc: formatPercentages, style: { color: '#353535' } },
                { count: aggregateSum(this.state.companies, 'sum'), formatFunc: formatRubMoney, style: { color: '#353535' } }]
            }}
          />
        </div>
        <div className="col-main">
          <Paper elevation={1} style={{ height: '44px', width: '1014px', margin: '6px 0px 7px 10px' }}>
            <span style={{
              fontSize: '13px',
              fontWeight: '400',
              color: '#3a3a3a',
              marginLeft: '11px',
              marginRight: '7px',
              display: 'inline-block',
              top: '-8px',
              position: 'relative'
            }}
            >
                С:
            </span>
            <DatePickers defaultValue={dateToHtmlInputDate(new Date(this.state.filter['date-from']))} onChange={this.onDateChangeFrom.bind(this)} style={{ top: '-7px' }} />
            <span style={{
              fontSize: '13px', fontWeight: '400', color: '#3a3a3a', marginLeft: '11px', marginRight: '7px', display: 'inline-block', top: '-8px', position: 'relative'
            }}
            >По:
            </span>
            <DatePickers defaultValue={dateToHtmlInputDate(new Date(this.state.filter['date-to']))} onChange={this.onDateChangeTo.bind(this)} style={{ top: '-7px' }} />
            <FormControlLabel
              style={{ position: 'relative', marginLeft: '0px', top: '-3px' }}
              control={(
                <Checkbox
                  checked={this.state.showTable}
                  onChange={this.showTableClick.bind(this)}
                  // value={true}
                  color="primary"
                />
              )}
              label="Показать таблицу"
            />

          </Paper>

          <div elevation={1} style={{ width: '1014px', margin: '6px 0px 0px 10px' }}>
            <PieChart width={1014} height={300}>
              <Pie
                data={tableData}
                cx={507}
                cy={141}
                // labelLine={false}
                // label={renderCustomizedLabel}
                outerRadius={145}
                fill="#8884d8"
                dataKey="percent"
                margin={{
                  top: 0, right: 0, left: 0, bottom: 0
                }}
                // label
              >
                {
                  tableData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
                }
              </Pie>
              <Tooltip />
            </PieChart>
          </div>

          <EjectedList
            {...passedProps}
            title={this.getTitle(this.props.companies, this.state.filter)}
            sort={{ field: 'count', order: SORT_ASC }}
            perPage={50}
            filter={this.state.filter}
            bulkActions={false}
            style={{ width: '1024px' }}
            headercomponent={Header}
            pagination={null}
          >
            {this.state.showTable ? <CustomerDatagrid subjects={this.props.subjects} showCounters /> : null}
          </EjectedList>
        </div>
      </div>
    );
  }
}


export default connect(state => ({
  resIds: state.admin.resources['statistics-subject'].list.ids,
  resData: state.admin.resources['statistics-subject'].data,
  companies: state.sc.companies,
  plans: state.sc.plans,
  subjects: state.sc.subjects
}), { updateCounters: updateCountersAction })(List);



// WEBPACK FOOTER //
// ./src/pages/admin/statistics_subject/List.js